import {generateRandomString} from './generateRandomString';

export function generateId(name: string) {
  return `id://${name}/${generateRandomString()}`;
}
